/** Coalesce rapid deliveries (pointermove, scroll) to one callback per frame. */
export type RafScheduler<T> = {
  schedule: (value: T) => void;
  flush: () => void;
  cancel: () => void;
};

export function createRafScheduler<T>(deliver: (value: T) => void): RafScheduler<T> {
  let pending: T | null = null;
  let hasPending = false;
  let id: number | null = null;

  const run = () => {
    id = null;
    if (!hasPending) return;
    const value = pending as T;
    pending = null;
    hasPending = false;
    deliver(value);
  };

  return {
    schedule(value) {
      pending = value;
      hasPending = true;
      if (id == null) id = requestAnimationFrame(run);
    },
    flush() {
      if (id != null) {
        cancelAnimationFrame(id);
        id = null;
      }
      if (!hasPending) return;
      const value = pending as T;
      pending = null;
      hasPending = false;
      deliver(value);
    },
    cancel() {
      if (id != null) {
        cancelAnimationFrame(id);
        id = null;
      }
      pending = null;
      hasPending = false;
    },
  };
}
